import React from "react";
import { twMerge } from "tailwind-merge";
import { Autocomplete, TextField } from "@mui/material";
import { PaperAddNew } from "./PaperAddNew";
import { PaperSelectAll } from "./PaperSelectAll";

const BaseAutocompleteContext = React.createContext(null);

export const useBaseAutocompleteContext = () => {
  const context = React.useContext(BaseAutocompleteContext);

  if (!context) throw new Error("BaseAutocomplete Context not provided!");

  return context;
};
const BaseAutocomplete = ({
  label,
  placeholder,
  required = false,
  fullWidth = false,
  className,
  error = false,
  size = "small",
  helperText = "",
  getOptionLabel = (option) => option?.label || "",
  isOptionEqualToValue = (option, value) => option?.id === value?.id,
  variant = "outlined",
  onInputChange,
  ...props
}) => {
  const [inputValue, setInputValue] = React.useState("");

  let value = props?.value || "";

  if (!value && props.multiple) value = [];

  const handleInputChange = (event, newInputValue, reason) => {
    setInputValue(newInputValue);
    if (onInputChange) {
      onInputChange(event, newInputValue, reason);
    }
  };
  return (
    <BaseAutocompleteContext.Provider
      value={{
        ...props,
        inputValue,
      }}
    >
      <div className={twMerge("w-60", className, fullWidth && "w-full")}>
        <Autocomplete
          size="small"
          autoHighlight
          getOptionLabel={getOptionLabel}
          isOptionEqualToValue={isOptionEqualToValue}
          renderInput={(params) => (
            <TextField
              {...{
                ...params,
                required,
                label,
                placeholder,
                error,
                helperText,
              }}
              variant="outlined"
              size="small"
            />
          )}
          {...{
            ...props,
            value,
            getOptionLabel,
            isOptionEqualToValue,

            inputValue,
            onInputChange: handleInputChange,
          }}
        />
      </div>
    </BaseAutocompleteContext.Provider>
  );
};

BaseAutocomplete.PaperAddNew = PaperAddNew;

BaseAutocomplete.PaperSelectAll = PaperSelectAll;

export default BaseAutocomplete;
